
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/results/[[...params]]",
      function () {
        return require("private-next-pages/results/[[...params]]/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/results/[[...params]]"])
      });
    }
  